import { NetworkStatus } from '@cbridge-utils/network';
import { ISymbolStore } from './symbol.interface';

export const MAX_SYMBOLS_COUNT = 500;

export const symbolInitialState: ISymbolStore = {
  data: {},
  baseSymbolsData: {
    list: [],
    networkStatus: NetworkStatus.None,
  },
  filteredCount: 0,
  totalCount: MAX_SYMBOLS_COUNT,
  networkStatus: NetworkStatus.None,
};
